import { useTranslation } from "react-i18next";
import { Icon } from "@/ui/icon/Icon";
import styles from "./InstagramSearchSelectionCount.module.css";

interface InstagramSearchSelectionCountProps {
  count: number;
  onClear?: () => void;
}

export const InstagramSearchSelectionCount: React.FC<
  InstagramSearchSelectionCountProps
> = ({ count, onClear }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.count}>
      <div className={styles.value}>{count}</div>
      <div className={styles.text}>{t("selection.selected")}</div>
      <Icon
        className={styles.icon}
        name="cross_24px_regular"
        onClick={onClear}
      />
    </div>
  );
};
